<section class="header-container">
  <div class="route-container">
    <span (click)="navigateBacK()">{{previewsPage}}</span>
    <i class="db-icon db-icon-ds-arrow-right"></i>
    <span>{{currentPage}}: #{{orderId}}</span><span class="ds-test-small" *ngIf="!!orderHasTestPayment">{{ 'text_test' | dbText }}</span>
  </div>
  <div class="refund-button">
    <a class="ds-btn-xxs ds-btn-outline-gray mr10"
       *ngIf="!orderHasRefunds"
       (click)="toggleRefundSection(true)">
      <span>{{ 'text_fullRefund' | dbText }}</span>
    </a>
    <a class="ds-btn-xxs ds-btn-black"
      *ngIf="!fullRefunded"
      (click)="toggleRefundSection()">
      <span>{{ 'text_refund' | dbText }}</span>
    </a>
  </div>
</section>

